document.addEventListener('DOMContentLoaded', () => {
  const imageInput = document.querySelector('.c-image-upload__input');
  if (!imageInput) return;

  imageInput.addEventListener('change', (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const preview = document.querySelector('.c-image-upload__img');
    const placeholder = document.querySelector('.c-image-upload__placeholder');

    if (preview && placeholder) {
      const reader = new FileReader();

      reader.onload = (e) => {
        preview.src = e.target.result;
        preview.classList.remove('hidden');
        placeholder.classList.add('hidden');
      };

      reader.readAsDataURL(file);
    }
  });
}); 